<template>
  <div
    class="flex flex-wrap col-12 items-center h4n border-top border-bottom py2 px3"
  >
    <div class="flex col-12 h3 bold mb2">Récapitulatif de commande:</div>
    <div
      v-for="(detail, index) in details"
      v-if="details.some((d) => d.tda_info)"
      :key="`tda_info_${index}`"
      class="flex col-12 px4 pb2 justify"
    >
      <div v-if="detail && detail.tda_info" v-html="detail.tda_info"></div>
    </div>
    <div class="flex col-12">
      Participant: {{ details[0].participant.firstname }}
      {{ details[0].participant.lastname }}
    </div>
    <div class="flex flex-wrap col-12 p2">
      <div class="flex col-12">
        De
        {{
          frenchTime(
            parseInt(commonAttributes.session.start_time),
            "dd/MM/yyyy"
          )
        }}
        au
        {{
          frenchTime(parseInt(commonAttributes.session.last_time), "dd/MM/yyyy")
        }}
      </div>
      <div class="flex col-12">
        De
        {{
          frenchTime(parseInt(commonAttributes.session.start_time), "HH'h'mm")
        }}
        à
        {{ frenchTime(parseInt(commonAttributes.session.end_time), "HH'h'mm") }}
      </div>
    </div>
  </div>
</template>

<script>
import { frenchTime } from '@/utils/utils';

export default {
  props: {
    details: Array,
    commonAttributes: Object
  },
  methods: { frenchTime }
};
</script>
